"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rspCompProgressLinearToken = void 0;
var component_2023_design_tokens_1 = require("@rentspree/component-2023-design-tokens");
var component_2023_utils_token_adapter_1 = require("@rentspree/component-2023.utils.token-adapter");
exports.rspCompProgressLinearToken = (0, component_2023_utils_token_adapter_1.flattenToken)(component_2023_design_tokens_1.compTokens.progressLinears);
//# sourceMappingURL=linear-progress.js.map